import { render, staticRenderFns } from "./FirstVersionIntegration.vue?vue&type=template&id=33d1367f&scoped=true"
import script from "./FirstVersionIntegration.vue?vue&type=script&lang=js"
export * from "./FirstVersionIntegration.vue?vue&type=script&lang=js"
import style0 from "./FirstVersionIntegration.vue?vue&type=style&index=0&id=33d1367f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d1367f",
  null
  
)

export default component.exports